module.exports = __webpack_public_path__ + "static/media/gipsy_rome.a13304b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/normals/gipsy_rome.jpg
// module id = 410
// module chunks = 0